import { stripHtml } from './note-utils';

export function isCommentRichTextEmpty(html: string): boolean {
  return stripHtml(html).length === 0;
}

export function looksLikeCommentHtml(value: string): boolean {
  return /<[a-z][\s\S]*>/i.test(value);
}
